
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/end-of-life-guide",
      function () {
        return require("private-next-pages/end-of-life-guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/end-of-life-guide"])
      });
    }
  